var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStatistic2 = function SvgStatistic2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 16.71h1.6a.2.2 0 0 0 .2-.2V9.54a.2.2 0 0 0-.2-.2h-6.96a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h3.75l-5.58 5.58c-.06.06-5.17 4.62-7.19 6.49l-4.68-4.68a.193.193 0 0 0-.28 0L2 27.59V.2a.2.2 0 0 0-.2-.2H.2a.2.2 0 0 0-.2.2V32h31.8a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2H2.41L11 21.41 16 26l14-13.24v3.75c0 .11.09.2.2.2"
  })));
};
export default SvgStatistic2;